import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {},
    byProfile: {}
});

const getSegments = (state, recommendation) => {
    if (state.byProfile[recommendation.userProfileId]) {
        if (state.byProfile[recommendation.userProfileId][recommendation.parentType]) {
            state.byProfile[recommendation.userProfileId][recommendation.parentType][recommendation._id] =
                recommendation;
        } else {
            state.byProfile[recommendation.userProfileId][recommendation.parentType] = {
                [recommendation._id]: recommendation
            };
        }
    } else {
        state.byProfile[recommendation.userProfileId] = {
            [recommendation.parentType]: {
                [recommendation._id]: recommendation
            }
        };
    }
    state.byId[recommendation._id] = recommendation;
};

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case ACTIONS.PUT_RECOMMENDATIONS:
        case ACTIONS.POST_RECOMMENDATIONS: {
            const { recommendation } = action.payload;
            const newState = { ...state };
            getSegments(newState, recommendation);
            return {
                ...newState
            };
        }
        case ACTIONS.GET_MANY_RECOMMENDATIONS_COLLECTIONS:
        case ACTIONS.GET_MANY_RECOMMENDATIONS_PATHWAYS:
        case ACTIONS.GET_MANY_RECOMMENDATIONS_LEARNING_ASSETS: {
            const { recommendations } = action.payload;
            const newState = { ...state };
            if (recommendations.length) {
                recommendations.forEach((recommendation) => {
                    getSegments(newState, recommendation);
                });
            }
            return {
                ...newState
            };
        }
        case ACTIONS.PUT_MANY_RECOMMENDATIONS: {
            const { recommendations } = action.payload;
            const newState = { ...state };
            recommendations.forEach((rec) => getSegments(newState, rec));

            return { ...newState };
        }
        default:
            return state;
    }
};
